module.exports = __webpack_public_path__ + "static/media/imgn-quienessomos.9c9b52c0.jpg";